import React from "react";

export default class AdminSectionBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) return (
      <div className="adminAlert adminAlertError" role="alert">
        This administration section could not be displayed. Other sections remain available.
        <button type="button" className="adminSecondaryButton"
          onClick={() => this.setState({ failed: false })}>Retry section</button>
      </div>
    );
    return this.props.children;
  }
}
